import React, { useEffect, useMemo } from 'react';

import { GroupSelector } from './GroupSelector';
import './styles.scss';
import { RECENT_GROUP_ID, ROOT_GROUP_ID } from '../../../../constants/group';
import { CUSTOM_GROUP_ID } from '../constant';
import { GroupCameras } from './GroupCameras';
import { AllCamerasPinnedGroup, AllCamerasRootGroup } from './AllCameras'
// import { AllCameras } from './AllCameras';

const allOption = {
  label: 'All',
  value: ROOT_GROUP_ID,
};

const pinnedOption = {
  label: 'Pinned',
  value: RECENT_GROUP_ID,
};

const customOption = {
  label: 'Custom',
  value: CUSTOM_GROUP_ID,
};

export const ListCamera = ({
  getIsCameraPinned,
  onPinCamera,
  namespace,
  selectedGroup,
  onSelectGroup,
  selectedSerial,
  onSelectCamera,
  cameras,
  onUpdateCamera,
  onUpdateStream,
  updateReturn,
  onCameraRemoved,
}) => {
  const selectedGroupId = selectedGroup?.id;
  const additionalOptions = useMemo(() => {
    if (!selectedGroup) {
      return [pinnedOption, allOption];
    }

    if (selectedGroup.id === CUSTOM_GROUP_ID) {
      return [customOption, pinnedOption, allOption];
    }

    return [
      {
        label: selectedGroup.name,
        value: selectedGroup.id,
      },
      pinnedOption,
      allOption,
    ];
  }, [selectedGroup]);

  return (
    <div className="camera-list-camera">
      <GroupSelector
        namespace={namespace}
        additionalOptions={additionalOptions}
        selectedId={selectedGroupId}
        onSelect={onSelectGroup}
      />
      {selectedGroupId !== ROOT_GROUP_ID && selectedGroupId !== RECENT_GROUP_ID && (
        <GroupCameras
          key={selectedGroupId}
          shouldFetch={selectedGroupId !== CUSTOM_GROUP_ID}
          getIsCameraPinned={getIsCameraPinned}
          onPinCamera={onPinCamera}
          selectedSerial={selectedSerial}
          onSelectCamera={onSelectCamera}
          namespace={namespace}
          selectedGroupId={selectedGroupId}
          cameras={cameras}
          groupId={selectedGroupId}
          onUpdateCamera={onUpdateCamera}
          onUpdateStream={onUpdateStream}
          updateReturn={updateReturn}
          onCameraRemoved={onCameraRemoved}
        />
      )}
      {
        selectedGroupId === ROOT_GROUP_ID && (
          <AllCamerasRootGroup
            namespace={namespace}
            onSelectCamera={onSelectCamera}
            selectedSerial={selectedSerial}
            getIsCameraPinned={getIsCameraPinned}
            onPinCamera={onPinCamera}
            onUpdateCamera={onUpdateCamera}
            onUpdateStream={onUpdateStream}
            updateReturn={updateReturn}
          />
        )
      }
      {selectedGroupId === RECENT_GROUP_ID && (
        <AllCamerasPinnedGroup
          namespace={namespace}
          onSelectCamera={onSelectCamera}
          selectedSerial={selectedSerial}
          getIsCameraPinned={getIsCameraPinned}
          onPinCamera={onPinCamera}
          cameras={cameras}
          onUpdateCamera={onUpdateCamera}
          onUpdateStream={onUpdateStream}
          updateReturn={updateReturn}
        />
      )}
    </div>
  );
};
